/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit SortItem/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import Asc from './Asc/index'
import Desc from './Desc/index'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function SortItem({
  children,
  viewPath = "/App/Account/Content/Tasks/New/Content/Board/Content/Main/Board/Board/Content/StageHeader/Sort/Content/SortItem"
  
}) {
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let sortFilterTextValueData = fromData.useDataValue({ viewPath,
context: 'sort_filter',
path: 'text',
})
let dtColorsNeutral900 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.900'
        })
  return (<React.Fragment
>
<div
  data-testid="SortItem.Vertical"
  data-view-path={viewPath}
 style={{'--mb-1-22ETUC': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs}}
 className={`views-block ${styles.Vertical}`}
>
<div
  data-testid="SortItem.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 data="sort_filter.text"
 text={sortFilterTextValueData}
 color={dtColorsNeutral900}
/>
<div
  data-testid="SortItem.Horizontal:1"
  data-view-path={viewPath}
 style={{'--g-2-22ETUC': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs}}
 className={`views-block ${styles.Horizontal1}`}
>
<Desc
  viewPath={`${viewPath}/Desc`}
/>
<Asc
  viewPath={`${viewPath}/Asc`}
/>
</div>
</div>
</div>
{children}
</React.Fragment>)
}